<template>
  <div>
  <b-dropdown id="ddown" class="mr-1" text="Lielapjopma darbības">
    <b-dropdown-group id="bulk-action-group-1" header="Atgādinājumi">
      <b-dropdown-item-button @click="$bvModal.show('modal-notify-users')">Atgādinājumi visiem lietotājiem</b-dropdown-item-button>
      <b-dropdown-item-button  @click="$bvModal.show('modal-notify-users-select')">Atgādinājumi konkrētiem lietotājiem</b-dropdown-item-button>
    </b-dropdown-group>
    <b-dropdown-divider></b-dropdown-divider>      
    <b-dropdown-item-button @click="resetAllPasswords">Nomainīt lietotāju paroles</b-dropdown-item-button>
  </b-dropdown>
  <NotifyAllActiveUsers/>
  <NotifySpecificUsers/>
</div>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex';
import axios from 'axios';
import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
import * as rootStoreTypes from '../../vuex/root.store-types';

import NotifyAllActiveUsers from './modals/NotifyAllActiveUsers.vue';
import NotifySpecificUsers from './modals/NotifySpecificUsers.vue';

export default {
    name: "user-bulk-actions",
    components: { NotifyAllActiveUsers, NotifySpecificUsers },
    computed: {
        ...mapGetters("company", {
            /** @type {Company|*} */
            currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
        }),
    },
    methods: {
        ...mapMutations({
            /** @type {function|*} */
            setAlertData: rootStoreTypes.SET_ALERT_DATA,
        }),
        resetAllPasswords() {
            this.$bvModal.msgBoxConfirm("Šī darbība izveidos jaunas pagaidu paroles visiem lietotājiem!", {
                title: "Apstirprināt paroles maiņu",
                okTitle: "Apstiprināt",
                cancelTitle: "Atcelt",
                centered: true
            }).then(async (value) => {
                if (value) {
                    const { data: { success } } = await axios.post(`/api/companies/${this.currentCompany.id}/users/reset-all-passwords`);
                    if (success) {
                        this.setAlertData({ type: "success", dismissSecs: 10, message: "Lietotāja paroles nomainītas!" });
                    }
                }
            }).catch(() => {
                this.setAlertData({ type: "danger", dismissSecs: 10, message: "Paroles maiņas laikā notika kļūda!" });
            });
        },
    }
}
</script>
